import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectVirtualCardIdFromRoute } from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.selectors'
import UpdateVirtualCardForm from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardForm'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { updateBillPayUrl } from 'src/navigation/urls'
import {
  AutomationRuleListSortField,
  useAutomationRuleList,
} from 'src/queries/organizations/automationRules.queries'
import {
  useQueryVirtualCardDetail,
  useQueryVirtualCardPermissions,
} from 'src/queries/virtualCards.queries'

const UpdateVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const { data: virtualCard, isLoading: isVirtualCardLoading } =
    useQueryVirtualCardDetail({ virtualCardId })
  const { data: virtualCardPermissions, isLoading: isPermissionsLoading } =
    useQueryVirtualCardPermissions({ virtualCardId })
  // EX-40651: GET /users/{id} 404s for users the viewer cannot read.
  const recipient = virtualCard?.recipient
  const cardholder = virtualCard?.cardholder
  const { isPending: rulesPending } = useAutomationRuleList({
    filters: {
      sortField: AutomationRuleListSortField.CreatedAt,
      sortDirection: 'DESC',
      fundingSourceIds: [virtualCardId],
    },
    enabled: virtualCardId !== undefined,
  })

  useEffect(() => {
    if (virtualCard === undefined) return

    if (virtualCard.isBillPay) {
      // user is trying to access a bill pay card, redirect to the bill pay url
      dispatch(connectedReplace(updateBillPayUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <UpdateVirtualCardForm
        virtualCardId={virtualCardId}
        virtualCard={virtualCard}
        virtualCardPermissions={virtualCardPermissions}
        recipient={recipient}
        cardholder={cardholder}
        loadingFlyout={
          isVirtualCardLoading || isPermissionsLoading || rulesPending
        }
      />
    </RightFlyout>
  )
}

export default UpdateVirtualCard
